import { Box, Grid, Typography } from '@mui/material';
import { useId } from 'react';
import { IAsset } from '../../../../../Interfaces/Asset/IAsset';
import { IConfig } from '../../../../../Interfaces/IConfig';
import { IDocument } from '../../../../../Interfaces/IDocument';
import { ILegalTransactionRelationship } from '../../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { CustomeSlide } from '../../../../core/CustomeSlide';
import { useDialogContext } from '../../../../core/DialogPresenter/DialogContext';
import { useRegisterDialogPage } from '../../../../core/DialogPresenter/useRegisterDialogPage';
import { SendLegalClient } from '../../../../LegalClient/SendLegalClient';
import NewFamilyTree from '../components/NewFamilyTree/NewFamilyTree';
import { TestamentAssetsSummary } from '../components/TestamentAssetsSummary';
import { DialogLegalTransactionTypeMapping } from '../../../../../Interfaces/IDialogLegalTransactionTypeMapping';

export type ITestamentSummaryProps = {
  configObject: IConfig;
  assetArray: IAsset[];
  relationshipArray: ILegalTransactionRelationship[];
  setRelationshipArray: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationship[]>
  >;
  documentArray: IDocument[];
};

export function TestamentSummary({
  configObject,
  assetArray,
  documentArray,
  relationshipArray,
  setRelationshipArray,
}: ITestamentSummaryProps) {
  const id = useId();
  const { handleNext, handleBack } = useDialogContext();

  const pageNumber = useRegisterDialogPage(id, {
    title: 'Zusammenfassung des Testaments',
  });

  return pageNumber === null ? null : (
    <CustomeSlide key={id} pageNumber={pageNumber} appear={false}>
      <Grid container spacing={2}>
        <Box sx={{ mt: 5 }} />
        <Grid item xs={12}>
          <Typography variant='h4' sx={{ mb: 3 }}>
            Zusammenfassung des Testaments
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography>
            In diesem Abschnitt können Sie die Verwandten des Erblassers
            angeben. Diese Informationen sind wichtig für die rechtliche
            Gültigkeit des Testaments.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <NewFamilyTree
            relationshipArray={relationshipArray}
            setRelationshipArray={setRelationshipArray}
          />
        </Grid>

        <Grid item xs={12}>
          <TestamentAssetsSummary
            assetArray={assetArray}
            relationshipArray={relationshipArray}
          />
        </Grid>

        <Grid item xs={12}>
          <SendLegalClient
            configObject={configObject}
            idLegalTransactionType={DialogLegalTransactionTypeMapping.Testament}
            relationshipArray={relationshipArray}
            setRelationshipArray={setRelationshipArray}
            assetArray={assetArray}
            documentArray={documentArray}
            handleBack={handleBack}
            handleNext={handleNext}
          />
        </Grid>
      </Grid>
    </CustomeSlide>
  );
}
